module.exports = __webpack_public_path__ + "static/media/pedalo.624c660c.png";